export default __webpack_public_path__ + "static/media/MadeleineLovelace.ac9b8dbe.png";